import { defineStore } from 'pinia'

export const useModals = defineStore('modalsStore', {
  state: () => ({
    count: 0,
  }),
  getters: {
    hasActiveModal(state) {
      return !!state.count
    },
  },
})
